import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import { Notification } from './notification.types';
const notificationApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getNotificationsCount: build.mutation<ApiResponse<number>, ApiRequest<any>>({
            query: () => ({
                url: `/app/notifications/count`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<number>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getNotifications: build.mutation<ApiResponse<Notification[]>, ApiRequest<any>>({
            query: (payload) => ({
                url: `/app/notifications`,
                method: 'GET',
                params: payload
            }),
            transformResponse: (response: ApiResponse<Notification[]>) => ({
                code: response.code,    
                data: response.data,
                status: response.status
            })
        }),

        putNotificationsAsRead: build.mutation<ApiResponse<null>, ApiRequest<any>>({
            query: () => ({
                url: `/app/notifications/read-all`,
                method: 'PUT'
            }),
            transformResponse: (response: ApiResponse<null>) => ({
                code: response.code,    
                data: response.data,
                status: response.status
            })
        }),

    })
});

export const {
    useGetNotificationsCountMutation,
    useGetNotificationsMutation,
    usePutNotificationsAsReadMutation
} = notificationApi;
